import { Anchor, Breadcrumbs, Grid, Text } from '@mantine/core';
import queryString from 'query-string';
import { useState } from 'react';
import { useLocation, useParams } from 'react-router';
import SenderVerificationAlert from '../../components/SenderVerificationAlert';
import EmailsNewForm from '../../components/Emails/EmailsNewForm';
import Metadata from '../../components/Metadata';
import GuidanceModal from '../../components/UserFlows/guidanceModal';
import { Page } from '../../constants/pageTitles';

const page = `${Page['email']}`;

const EmailsNewPage = () => {
  const location = useLocation();
  const [guidanceShow, setGuidanceShow] = useState(false);
  const [email, setEmail] = useState();

  const { accountId, domainId } = useParams();

  const editor = queryString.parse(location.search).editor;
  const from = queryString.parse(location.search).from;
  const templateId = queryString.parse(location.search).templateId;

  const breadcrumbItems = [
    { title: 'Home', href: `#/accounts/${accountId}/domains/${domainId}/analytics` },
    { title: page, href: `#/accounts/${accountId}/domains/${domainId}/emails` },
    { title: 'New' },
  ].map((item, index) =>
    item.href ? (
      <Anchor href={item.href} key={index}>
        {item.title}
      </Anchor>
    ) : (
      <Text key={index}>{item.title}</Text>
    )
  );

  return (
    <>
      <Metadata title={`${page} | New`} />
      <Breadcrumbs mb="md">{breadcrumbItems}</Breadcrumbs>

      <SenderVerificationAlert />
      <GuidanceModal
        type="email"
        redirect={`/accounts/${accountId}/domains/${domainId}/emails`}
        show={guidanceShow}
        elementTypes={['campaigns', 'workflows']}
        element={email}
        setShow={() => setGuidanceShow(false)}
        newElement={true}
      />
      <Grid>
        <Grid.Col span={12}>
          <EmailsNewForm
            from={from}
            editor={editor}
            onCreate={(cb) => {
              setEmail(cb);
              setGuidanceShow(true);
              if (typeof cb === 'function') {
                cb();
              }
            }}
            templateId={templateId}
          />
        </Grid.Col>
      </Grid>
    </>
  );
};

export default EmailsNewPage;
